import { FC } from "react";

import classNames from "classnames";

import { Shelf, Stack } from "../../../layout";
import { BaseColumnProps } from "../BaseColumnProps";
import { ColumnElementConstructor } from "../ColumnElementConstructor";
import { getFormattedValue } from "../helpers/getFormattedValue";
import { Custom } from "./Custom";

import styles from "./styles.module.css";

/**
 * The `Currency` component properties.
 */
export interface CurrencyProps extends Omit<BaseColumnProps, "align"> {
  /**
   * The minimum number of fraction digits to use The maximum number of fraction digits to use and possible values are from 0 to 100.
   */
  readonly minimumFractionDigits?: number;

  /**
   * The maximum number of fraction digits to use The maximum number of fraction digits to use and possible values are from 0 to 100.
   */
  readonly maximumFractionDigits?: number;
}

/**
 * Column which displays formatted currency values.
 */
export const Currency: FC<CurrencyProps> = (props) => {
  const { minimumFractionDigits, maximumFractionDigits } = props;

  return (
    <Shelf>
      <Stack spacing="none" alignment="left">
        $
      </Stack>
      <Shelf.Spacer />
      <Shelf spacing="none">
        <Custom {...props}>
          {(value) => {
            if (value === null) return "--";
            if (typeof value === "undefined") return "--";
            if (typeof value === "string") return getFormattedValue(value, minimumFractionDigits, maximumFractionDigits) || "--";
            if (typeof value === "number") return getFormattedValue(value.toString(), minimumFractionDigits, maximumFractionDigits);
          }}
        </Custom>
      </Shelf>
    </Shelf>
  );
};

(Currency as ColumnElementConstructor<CurrencyProps>).headerAlignment = "right";
(Currency as ColumnElementConstructor<CurrencyProps>).className = classNames(styles.Numerical, "currency");
